export  async function donwloadImageByUrl(url: string) {
    if (!url) return null

    try {
      const normalizedUrl = url.trim()

      if (!/^https?:\/\//i.test(normalizedUrl)) {
        return null
      }

      const response = await fetch(`${process.env.REACT_APP_API_URL}/upload-images/download-image-s3?url=${encodeURIComponent(normalizedUrl)}`, {
        method: 'GET',
        headers: {
          Authorization: `Bearer ${
            JSON.parse(localStorage.getItem('loginInfo_ninegrid_access') || localStorage.getItem('loginInfo_ninegrid_adm') || '{}')?.accessToken
          }`,
        },
      })

      if (!response.ok) {
        throw new Error(`Falha ao baixar a imagem: ${response.status}`)
      }

      const blob = await response.blob()

      if (!blob || blob.size === 0) {
        throw new Error('Imagem vazia ou inválida')
      }

      const mimeType = blob.type || response.headers.get('content-type') || 'image/jpeg'
      const extension = mimeType.includes('png') ? 'png' : mimeType.includes('webp') ? 'webp' : 'jpg'
      const file = new File([blob], `image.${extension}`, { type: mimeType })

      return file
    } catch (error) {
      console.error('Erro ao baixar a imagem:', error)
      return null
    }
  }